var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvidence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 74,
    viewBox: "0 0 100 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.9985H13.8008C9.32036 18.9985 7.07848 18.9985 5.36719 19.9795C3.86189 20.8423 2.63893 22.2182 1.87195 23.9116C1 25.8368 1 28.3589 1 33.3994V58.5994C1 63.6399 1 66.1588 1.87195 68.084C2.63893 69.7775 3.86189 71.1557 5.36719 72.0186C7.07681 72.9985 9.31598 72.9985 13.7876 72.9985H60.2124C64.684 72.9985 66.92 72.9985 68.6296 72.0186C70.1349 71.1557 71.3619 69.7775 72.1289 68.084M21 18.9985H53M21 18.9985C21 9.05741 28.1634 0.998535 37 0.998535C45.8366 0.998535 53 9.05741 53 18.9985M53 18.9985H60.2008C64.6812 18.9985 66.9183 18.9985 68.6296 19.9795C70.1349 20.8423 71.3619 22.2182 72.1289 23.9116C73 25.8349 73 28.354 73 33.3846",
    stroke: "#2F1612",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 60.6667L99 73M76.3889 64.7778C68.4421 64.7778 62 58.3357 62 50.3889C62 42.4421 68.4421 36 76.3889 36C84.3357 36 90.7778 42.4421 90.7778 50.3889C90.7778 58.3357 84.3357 64.7778 76.3889 64.7778Z",
    stroke: "#2F1612",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidence);
export default __webpack_public_path__ + "static/media/evidence.1a65dc7a3da0f003dd4b672822b15ccb.svg";
export { ForwardRef as ReactComponent };